import {
  Box,
  FormControlLabel,
  Switch,
  SxProps,
  TablePagination,
  TablePaginationProps,
} from '@mui/material';
// @mui
import { Theme } from '@mui/material/styles';
import { useLocales } from '../../locales';
//

// ----------------------------------------------------------------------

type Props = {
  dense?: boolean;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export default function TablePaginationCustom({
  dense,
  onChangeDense,
  rowsPerPageOptions = [25, 50, 100],
  sx,
  ...other
}: Props & TablePaginationProps) {
  const { translate } = useLocales();
  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        showFirstButton={true}
        showLastButton={true}
        {...other}
      />

      {onChangeDense && (
        <FormControlLabel
          label={`${translate('dense')}`}
          control={<Switch checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: {
              sm: 'absolute',
            },
          }}
        />
      )}
    </Box>
  );
}
